import ReactGA from 'react-ga4'

function getTrafficCategory(): 'paid_social' | 'social' | 'organic' {
    const urlParams = new URLSearchParams(window.location.search)
    const hasSmidCookie = document.cookie.split('; ').some(c => c.startsWith('smid='))
    const isPaidSocial = urlParams.get('PSM') === 'true'
        || urlParams.get('utm_medium') === 'paid-social'
        || hasSmidCookie
    const isSocial = urlParams.get('utm_medium') === 'social'

    return isPaidSocial ? 'paid_social' : isSocial ? 'social' : 'organic'
}

export function trackPhoneCallClick() {
    ReactGA.event('phone_number_counter', {
        event_category: getTrafficCategory(),
        event_label: 'flights_pages',
    })
}
